import { render, staticRenderFns } from "./CustomDistribution.vue?vue&type=template&id=c4541664&"
import script from "./CustomDistribution.vue?vue&type=script&lang=ts&"
export * from "./CustomDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports